"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PHARMACY_BILLING_PERMISSIONS = exports.PharmacyBillingPermissions = void 0;
/**
 * Permission string catalog for Pharmacy Billing & Dispensing (Stage 14,
 * UAT Gap-Fill) — a new bounded context, its own catalog, matching every
 * other bounded context's own precedent (Procurement/Inventory/Pricing
 * each have their own).
 */
exports.PharmacyBillingPermissions = {
    PHARMACY_SALE_READ: 'pharmacy-sale:read',
    PHARMACY_SALE_CREATE: 'pharmacy-sale:create',
    PHARMACY_SALE_BILL: 'pharmacy-sale:bill',
    PHARMACY_SALE_RETURN: 'pharmacy-sale:return',
    // Stage 15 (Enterprise Pharmacy Billing Workstation)
    PHARMACY_SALE_HOLD: 'pharmacy-sale:hold',
    PHARMACY_SALE_DISCOUNT_APPROVE: 'pharmacy-sale:discount-approve',
    // Enterprise Discount Engine — Admin Override. "Allow Edit Posted
    // Invoice Discount": posted invoices are otherwise immutable; only a
    // user holding this permission may edit a posted sale's bill-level
    // discount, mandatory reason + audit log either way.
    PHARMACY_SALE_DISCOUNT_EDIT_POSTED: 'pharmacy-sale:discount-edit-posted',
    PHARMACY_SALE_IP_BILL: 'pharmacy-sale:ip-bill',
    PHARMACY_BILLING_AUDIT: 'pharmacy-billing:audit',
    PHARMACY_BILLING_REVENUE_ANALYSIS: 'pharmacy-billing:revenue-analysis',
    PHARMACY_BILLING_COUNTER_PERFORMANCE: 'pharmacy-billing:counter-performance',
    PHARMACY_BILLING_OVERRIDE: 'pharmacy-billing:override',
    // Enterprise Billing Workstation — Payment Mode: Employee Credit / Company Credit.
    PHARMACY_CREDIT_LEDGER_READ: 'pharmacy-credit-ledger:read',
};
exports.ALL_PHARMACY_BILLING_PERMISSIONS = Object.values(exports.PharmacyBillingPermissions);
//# sourceMappingURL=pharmacy-billing.permissions.js.map